import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthActions } from "@convex-dev/auth/react";
import logo from "../../../assets/wiseapp-logo.png";
import { Alert, Button, InputWithLabel } from "../../../components/atoms/atoms";

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [codeSent, setCodeSent] = useState(false);

  const navigate = useNavigate();
  const { signIn } = useAuthActions();

  useEffect(() => {
    if (!error) return;
    const timer = setTimeout(() => setError(null), 5000);
    return () => clearTimeout(timer);
  }, [error]);

  useEffect(() => {
    if (!successMessage) return;
    const timer = setTimeout(() => setSuccessMessage(null), 5000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setError("Please enter your email address."); return; }
    setIsSubmitting(true);
    try {
      await signIn("password", { flow: "reset", email });
    } catch (err) {
      // Silently swallow "account not found" errors to prevent email enumeration.
      // Any other unexpected error is surfaced.
      const msg = err?.message || "";
      if (!msg.includes("InvalidAccountId") && !msg.includes("Could not find account")) {
        setError("Something went wrong. Please try again.");
        setIsSubmitting(false);
        return;
      }
    }
    // Always show success to prevent leaking whether the account exists.
    setCodeSent(true);
    setSuccessMessage("If an account exists for that email, you'll receive a reset code shortly.");
    setTimeout(() => navigate("/forgot-password?step=reset"), 2000);
    setIsSubmitting(false);
  };

  return (
    <div className="max-w-xl my-auto mx-auto lg:container">
      <div className="w-3/6 flex mx-auto mb-8">
        <img src={logo} alt="WiseApp Logo" />
      </div>
      <h1 className="text-2xl text-primary font-bold mb-5">Forgot Password</h1>
      {error && <Alert variant="destructive">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}

      {!codeSent && (
        <form onSubmit={handleSubmit}>
          <InputWithLabel
            inputId="email"
            labelName="Your Email"
            inputType="email"
            inputPlaceholder="----@-----.com"
            inputRequired
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            className="w-full mt-5"
            name={isSubmitting ? "Sending…" : "Send Reset Code"}
            disabled={isSubmitting}
          />
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
